import {Component, inject} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {NavigationService} from '../navigation-service/navigation.service';
import {SideMenuBehaviourStore} from '../state/side-menu-behaviour/side-menu-behaviour.store';
import {LanguageService} from '@em/user-account/data-access';
import {toSignal} from '@angular/core/rxjs-interop';
import {CommonModule} from '@angular/common';
import {LanguageCode} from '@em/shared/util-types';
import {SessionService} from '@em/auth/data-access';
import {EmIconButtonComponent} from '@em/shared/ui';
import {MatTooltip} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-page-wrapper-with-header',
  templateUrl: './page-wrapper-with-header.component.html',
  styleUrls: ['./page-wrapper-with-header.component.scss'],
  providers: [SideMenuBehaviourStore, NavigationService],
  imports: [
    RouterOutlet,
    CommonModule,
    EmIconButtonComponent,
    MatTooltip,
    TranslateModule,
  ],
})
export class PageWrapperWithHeaderComponent {
  private readonly _languageService = inject(LanguageService);
  private readonly _sessionService = inject(SessionService);
  private readonly _navigationService = inject(NavigationService);
  private readonly _router = inject(Router);

  readonly selectedLanguage = toSignal(this._languageService.observable());

  changeLanguage(newLang: LanguageCode) {
    this._languageService.change(newLang);
  }

  navigateToHome() {
    this._router.navigateByUrl('/');
  }

  isLoggedin() {
    return this._sessionService.isLoggedIn();
  }

  logout() {
    this._navigationService.logout();
  }
}
